<div class="main-grid">
  @if (!skeletonView) {
    @if (firstTrackingStatus) {
      <a
        [project-route]="link"
        [queryParams]="{ 'tabIndex': 2 }"
        class="tracking-status">
        <p class="status-name">{{ firstTrackingStatus.name }}</p>
        <app-date [date]="firstTrackingStatus.assignedAt"
          [tooltip]="'ORDERS.COMMON.TRACKING.assigned_at' | translate"
          icon="schedule">
        </app-date>
        <app-date [date]="firstTrackingStatus.createdAt"
          [tooltip]="'ORDERS.COMMON.TRACKING.tracked_at' | translate"
          icon="search">
        </app-date>
      </a>
    } @else {
      <span class="no-statuses">{{ 'ORDERS.COMMON.TRACKING.no_status' | translate }}</span>
    }
    <mat-divider></mat-divider>
    <div class="last-event">
      @if (lastTrackingError) {
        <div>
          {{ 'ORDERS.COMMON.TRACKING.last_error' | translate:({error: lastTrackingError}) }}
        </div>
      }
      @if (addedStatuesCount) {
        <div>
          {{ 'ORDERS.COMMON.TRACKING.added_count' | translate:({count: addedStatuesCount}) }}
        </div>
      }
      <app-date [date]="$safeNavigationMigration(tracking?.lastEvent.createdAt)"
        [tooltip]="'ORDERS.COMMON.TRACKING.last_tracking' | translate"
        icon="update">
      </app-date>
    </div>
  } @else {
    @if (firstTrackingStatus) {
      <ngx-skeleton-loader [count]="1" [theme]="{ margin: '0' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader [count]="1" [theme]="{ height: '30px', margin: '0' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader [count]="" [theme]="{ height: '30px', margin: '0' }"></ngx-skeleton-loader>
    }
    @if (!firstTrackingStatus) {
      <ngx-skeleton-loader [count]="1" [theme]="{ height: '30px', margin: '0' }"></ngx-skeleton-loader>
    }
    <mat-divider></mat-divider>
    @if (lastTrackingError) {
      <ngx-skeleton-loader [count]="1" [theme]="{ margin: '0' }"></ngx-skeleton-loader>
    }
    @if (addedStatuesCount) {
      <ngx-skeleton-loader [count]="1" [theme]="{ margin: '0' }"></ngx-skeleton-loader>
    }
    <ngx-skeleton-loader [count]="1" [theme]="{ height: '30px', margin: '0' }"></ngx-skeleton-loader>
  }
</div>
